
import axios, { Axios, AxiosRequestConfig } from 'axios'

import {  owlAddAjaxInfo } from '../utils/owl'
import { getI18nParams } from '../utils/i18n'
import { failToast } from '../utils/toast'
import { getLoginPath } from '@/pages/login/utils'


function onRequestError (param: {errorMessage: string, code: number, url: string, noToast?: boolean, requestParams?: any}) {
  owlAddAjaxInfo(
    {
      name: `Code: ${param.code}`,
      msg: `API: ${(param.url || '').replace(/\?.*$/, '')},  MSG: ${param.errorMessage}`,
      message: `API: ${(param.url || '').replace(/\?.*$/, '')},  MSG: ${param.errorMessage}`,
    },
    {
      // @ts-ignore
      fullPath: param.url || '',
      config: param.requestParams,
    },
  )
  if (!param.noToast) {
    failToast(param.errorMessage)
  }
}


const interceptors = {
// M端国际化请求头
  addMI18nHeader (config:any) {
    const i18nParams = getI18nParams()
    return { ...config, headers: { ...config.headers, ...i18nParams } }
  },

  // 响应拦截器：接口错误吗处理拦截器，0成功，其他为失败，可选接入
  codeCheckWithError (response: any) {
    const { data } = response
    const { msg, message, data: realData } = data || {}

    const errorCode = data?.status ?? data?.code
    const errorMessage = msg || message || realData?.msg || realData?.message

    if (errorCode) {
      const isLoginError = [
        10010001, // message: '鉴权失败，后端鉴权接口异常，一般不出现，作为兜底code'
        10010002, // message: 'cookie不存在，用户未登录'
        10010003, // message: 'cookie存在，有登录态，但登录态格式不合法，登录态被恶意篡改'
        10010004, // message: '该登录态对应的管理员不合法，该管理员已被移除，无权登录'
        10010005, // message: '该登录态对应的企业不合法，企业被删除或企业已停止合作'
      ].includes(errorCode)
      const currentHash = window.location.hash
      const isAuthWhitelistPage = currentHash.startsWith('#/login') || currentHash.startsWith('#/password/forget') // 鉴权白名单,无需登录
      const needToastWhiteList = ['/api/entweb/entAdmin/forgetPassword', '/api/entweb/entAdmin/changePassword']
      const hideToast = isLoginError && !needToastWhiteList.includes(response.config.url) // 默认登录错误直接跳转登录页不报错,但如果在鉴权白名单内,则需要报错(异常,白名单不应该报鉴权错误)

      onRequestError({ errorMessage, code: errorCode, url: response.config?.url, noToast: hideToast, requestParams: {
        headers: response.config?.headers,
        data: response.config?.data,
        params: response.config?.params,
        traceid: response.request?.traceid,
      } })
      console.log(isLoginError, isAuthWhitelistPage)

      if (isLoginError) {
        if (!isAuthWhitelistPage) {
          // 仅非登录页才跳转登录页
          window.location.replace(`${window.location.href.split('#')[0]}#${getLoginPath()}`)
        }
      }
      throw ({ message: errorMessage, data: realData })
    }
    return realData
  },
  // http错误
  onResponseError (error: any) {
    onRequestError({ errorMessage: error.message, code: error.status, url: error.config.url })
    return Promise.reject(error)
  },
}

const request = axios.create()
request.interceptors.request.use(interceptors.addMI18nHeader)
request.interceptors.response.use(interceptors.codeCheckWithError, interceptors.onResponseError)


// 定义函数类型
interface  RequestWithResponseType extends Omit<Axios, 'post' | 'get'> {
  post<T>(url: string, data?: {[k:string]: any}, config?: AxiosRequestConfig): Promise<T>;
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T>;
}

export default request as RequestWithResponseType

